import { addQueryParams } from '@core';
import '@models';
import {
  removeIdFromUrl,
  updateIdForSearchPage,
  removeIdFromBrandUrl,
} from '../../../../core/src/lib/utils/href.utils';
import { PageLoadEvent, PageName } from '../models';

export function addMerchantQueryParam(event: PageLoadEvent) {
  const isItCategoryOrProductOrBrand = [PageName.ProductPage, PageName.CategoryPage, PageName.BrandPage].includes(
    event.screenName as any,
  );
  if (isItCategoryOrProductOrBrand) {
    const { categoryId, productId, brandId } = event;
    const customParamValue = [
      [categoryId, 'c'],
      [brandId, 'b'],
      [productId, 'p'],
    ]
      .filter(([value]) => !!value)
      .map(([value, codingChar]) => `${codingChar}${value}`)
      .join('_');
    addQueryParams({ merchant: customParamValue });
  }
}

function removeAppleSuffixFromCategory(url: string): string {
  return url.replace('/category-apple', '/category');
}

const URL_OVERRIDE_BY_SCREEN_NAME: Partial<Record<PageName, (url: string) => string>> = {
  [PageName.ProductPage]: removeIdFromUrl,
  [PageName.CategoryPage]: (url: string) => {
    const urlWithoutIds = removeIdFromUrl(url, ['categoryId']);
    // If the URL contains "category-apple", remove the "-apple" suffix
    return urlWithoutIds.includes('/category-apple')
      ? removeAppleSuffixFromCategory(urlWithoutIds)
      : urlWithoutIds;
  },
  [PageName.BrandPage]: removeIdFromBrandUrl,
  [PageName.SearchResults]: updateIdForSearchPage,
};

export function analyticsOverrideUrls(event: PageLoadEvent): void {
  const { previousScreenName, previousUrl, screenName } = event;
  const overrideUrl = URL_OVERRIDE_BY_SCREEN_NAME[screenName as PageName];
  window.analyticsUrlOverride = overrideUrl ? overrideUrl(window.location.href) : window.location.href;
  window.CHASE.analytics.config.PageUrl = overrideUrl ? overrideUrl(window.location.href) : window.location.href;

  const previousFullUrl = previousUrl
    ? `${window.location.protocol}//${window.location.host}${previousUrl}`
    : document.referrer;
  const referrerOverrideUrl = URL_OVERRIDE_BY_SCREEN_NAME[previousScreenName as PageName];
  window.CHASE.analytics.config.PageReferrer = referrerOverrideUrl
    ? referrerOverrideUrl(previousFullUrl)
    : previousFullUrl;
}
